import { ICaptcha } from "@hooks/useCaptcha";
import { useField } from "@hooks/useField";
import React from "react";
import { StringField, StringFieldProps } from "./StringField";

export type CaptchaFieldProps = Omit<StringFieldProps, "field"> & {
    captcha: ICaptcha
}

export function CaptchaField ({ captcha, ...props }: CaptchaFieldProps) {
    const field = useField();

    return (
        <StringField 
            {...props}
            field={field}
            onValueChanged={captcha.handleMatch}
        />
    )
}